import { MessageDescriptor } from '@lingui/core';
import { Trans, msg } from '@lingui/macro';
import * as React from 'react';

export const globalPlusTwoLineTitleContent = (
  <Trans>
    Compte
    <br />
    Global+
  </Trans>
);

export const globalPlusTitle = (_: (descriptor: MessageDescriptor) => string) => _(msg`compte Global+`);
